import { useQueryClient } from 'react-query';

import { usePost } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useSaveProjectFilter = () => {
  const queryClient = useQueryClient();
  return usePost({
    url: ApiRoutesEnum.projectsSaveFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.projectsFilters]);
    },
  });
};
